// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
}

#app-container {
    display: flex;
    flex-flow: column nowrap;
    height: 100vh;
}

#map-container {
    position: relative;
    flex: 1;
    display: flex;
}

.mapboxgl-map {
    font: 500 14px Rajdhani,Arial,sans-serif
}

#earth-ranger-logo {
    position: absolute;
    padding: 10px 15px 10px 15px;
    top: 0;
    z-index: 1;
}

#earth-ranger-logo:hover {
    cursor: pointer;
}

#reset {
    z-index: 1;
    top: 90px;
    left: 10px;
    position: absolute;
    color: white;
}

#reset:hover {
    cursor: pointer;
}

@media screen {
    .mapboxgl-ctrl-attrib.mapboxgl-compact-show .mapboxgl-ctrl-attrib-button {
        background-color: rgba(0, 0, 0, 0.5);
    }
}

.mapboxgl-ctrl-top-left {
    top: 67pt;
}

.mapboxgl-ctrl-group button {
    width: 2.25rem;
    height: 2.25rem;
}

.mapboxgl-ctrl-bottom-left,
.mapboxgl-ctrl-bottom-right {
    margin-bottom: 6px;
}

/* Popup Styling */
.mapboxgl-popup {
    max-width: 100% !important;
}

/* Custom popup anchors */

.mapboxgl-popup-tip {
    display: none;
}

.mapboxgl-popup-anchor-bottom-left::before,
.mapboxgl-popup-anchor-bottom::before,
.mapboxgl-popup-anchor-bottom-right::before,
.mapboxgl-popup-anchor-bottom-left::after,
.mapboxgl-popup-anchor-bottom::after,
.mapboxgl-popup-anchor-bottom-right::after,
.mapboxgl-popup-anchor-top-left::before,
.mapboxgl-popup-anchor-top::before,
.mapboxgl-popup-anchor-top-right::before,
.mapboxgl-popup-anchor-top-left::after,
.mapboxgl-popup-anchor-top::after,
.mapboxgl-popup-anchor-top-right::after {
    content: "";
    display: block;
    width: 2rem;
    height: 1rem;
    position: absolute;
    margin: auto;
    z-index: -1;
}

.mapboxgl-popup-anchor-bottom-left::before,
.mapboxgl-popup-anchor-bottom::before,
.mapboxgl-popup-anchor-bottom-right::before,
.mapboxgl-popup-anchor-bottom-left::after,
.mapboxgl-popup-anchor-bottom::after,
.mapboxgl-popup-anchor-bottom-right::after {
    bottom: 2px;
}

.mapboxgl-popup-anchor-top-left::before,
.mapboxgl-popup-anchor-top::before,
.mapboxgl-popup-anchor-top-right::before,
.mapboxgl-popup-anchor-top-left::after,
.mapboxgl-popup-anchor-top::after,
.mapboxgl-popup-anchor-top-right::after {
    bottom: 100%;
    transform: rotate(180deg);
}

.mapboxgl-popup-anchor-bottom-left::before,
.mapboxgl-popup-anchor-bottom::before,
.mapboxgl-popup-anchor-bottom-right::before,
.mapboxgl-popup-anchor-top-left::before,
.mapboxgl-popup-anchor-top::before,
.mapboxgl-popup-anchor-top-right::before {
  background: var(--map-popup-border-color);
  filter: brightness(1.25);
  clip-path: polygon(100% 0, 100% 0, 50% 100%, 0 0);
}

.mapboxgl-popup-anchor-bottom-left::before,
.mapboxgl-popup-anchor-bottom-left::after,
.mapboxgl-popup-anchor-top-left::before,
.mapboxgl-popup-anchor-top-left::after {
  left: 0.75rem;
}

.mapboxgl-popup-anchor-bottom::before,
.mapboxgl-popup-anchor-bottom::after,
.mapboxgl-popup-anchor-top::before,
.mapboxgl-popup-anchor-top::after {
  left: 0;
  right: 0;
}

.mapboxgl-popup-anchor-bottom-right::before,
.mapboxgl-popup-anchor-bottom-right::after,
.mapboxgl-popup-anchor-top-right::before,
.mapboxgl-popup-anchor-top-right::after {
  right: 0.75rem;
}

.mapboxgl-popup-anchor-bottom-left::after,
.mapboxgl-popup-anchor-bottom::after,
.mapboxgl-popup-anchor-bottom-right::after,
.mapboxgl-popup-anchor-top-left::after,
.mapboxgl-popup-anchor-top::after,
.mapboxgl-popup-anchor-top-right::after {
  background: var(--map-popup-background-color);
  clip-path: polygon(calc(100% - 0px) 0, calc(100% - 2px) 0, calc(50% - 0px) calc(100% - 2px), 2px 0);
}

.mapboxgl-popup-content {
    all: unset;
    background: none;
    padding-bottom: 1rem;
    pointer-events: none !important;
    position: relative;
}

/* Attribution */

.mapboxgl-ctrl.mapboxgl-ctrl-attrib {
    box-sizing: content-box;
}

.mapboxgl-ctrl-attrib.mapboxgl-compact-show .mapboxgl-ctrl-attrib-button {
    background-color: unset;
}

.mapboxgl-ctrl-attrib-button:focus,
.mapboxgl-ctrl-group button:focus {
    outline: var(--focus-outline);
    box-shadow: none;
}

.mapboxgl-ctrl-attrib-inner {
    font-family: var(--map-body-font);
    font-size: var(--map-sub-body-font-size);
}`, "",{"version":3,"sources":["webpack://./../core/assets/mapstyle.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,MAAM;IACN,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,oCAAoC;IACxC;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;AAC9B;;AAEA,yBAAyB;;AAEzB;IACI,aAAa;AACjB;;AAEA;;;;;;;;;;;;IAYI,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;;;;;;IAMI,WAAW;AACf;;AAEA;;;;;;IAMI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;;;;EAME,yCAAyC;EACzC,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,OAAO;EACP,QAAQ;AACV;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;;;EAME,6CAA6C;EAC7C,mGAAmG;AACrG;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA,gBAAgB;;AAEhB;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,wCAAwC;AAC5C","sourcesContent":["body {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n#app-container {\r\n    display: flex;\r\n    flex-flow: column nowrap;\r\n    height: 100vh;\r\n}\r\n\r\n#map-container {\r\n    position: relative;\r\n    flex: 1;\r\n    display: flex;\r\n}\r\n\r\n.mapboxgl-map {\r\n    font: 500 14px Rajdhani,Arial,sans-serif\r\n}\r\n\r\n#earth-ranger-logo {\r\n    position: absolute;\r\n    padding: 10px 15px 10px 15px;\r\n    top: 0;\r\n    z-index: 1;\r\n}\r\n\r\n#earth-ranger-logo:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n#reset {\r\n    z-index: 1;\r\n    top: 90px;\r\n    left: 10px;\r\n    position: absolute;\r\n    color: white;\r\n}\r\n\r\n#reset:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n@media screen {\r\n    .mapboxgl-ctrl-attrib.mapboxgl-compact-show .mapboxgl-ctrl-attrib-button {\r\n        background-color: rgba(0, 0, 0, 0.5);\r\n    }\r\n}\r\n\r\n.mapboxgl-ctrl-top-left {\r\n    top: 67pt;\r\n}\r\n\r\n.mapboxgl-ctrl-group button {\r\n    width: 2.25rem;\r\n    height: 2.25rem;\r\n}\r\n\r\n.mapboxgl-ctrl-bottom-left,\r\n.mapboxgl-ctrl-bottom-right {\r\n    margin-bottom: 6px;\r\n}\r\n\r\n/* Popup Styling */\r\n.mapboxgl-popup {\r\n    max-width: 100% !important;\r\n}\r\n\r\n/* Custom popup anchors */\r\n\r\n.mapboxgl-popup-tip {\r\n    display: none;\r\n}\r\n\r\n.mapboxgl-popup-anchor-bottom-left::before,\r\n.mapboxgl-popup-anchor-bottom::before,\r\n.mapboxgl-popup-anchor-bottom-right::before,\r\n.mapboxgl-popup-anchor-bottom-left::after,\r\n.mapboxgl-popup-anchor-bottom::after,\r\n.mapboxgl-popup-anchor-bottom-right::after,\r\n.mapboxgl-popup-anchor-top-left::before,\r\n.mapboxgl-popup-anchor-top::before,\r\n.mapboxgl-popup-anchor-top-right::before,\r\n.mapboxgl-popup-anchor-top-left::after,\r\n.mapboxgl-popup-anchor-top::after,\r\n.mapboxgl-popup-anchor-top-right::after {\r\n    content: \"\";\r\n    display: block;\r\n    width: 2rem;\r\n    height: 1rem;\r\n    position: absolute;\r\n    margin: auto;\r\n    z-index: -1;\r\n}\r\n\r\n.mapboxgl-popup-anchor-bottom-left::before,\r\n.mapboxgl-popup-anchor-bottom::before,\r\n.mapboxgl-popup-anchor-bottom-right::before,\r\n.mapboxgl-popup-anchor-bottom-left::after,\r\n.mapboxgl-popup-anchor-bottom::after,\r\n.mapboxgl-popup-anchor-bottom-right::after {\r\n    bottom: 2px;\r\n}\r\n\r\n.mapboxgl-popup-anchor-top-left::before,\r\n.mapboxgl-popup-anchor-top::before,\r\n.mapboxgl-popup-anchor-top-right::before,\r\n.mapboxgl-popup-anchor-top-left::after,\r\n.mapboxgl-popup-anchor-top::after,\r\n.mapboxgl-popup-anchor-top-right::after {\r\n    bottom: 100%;\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.mapboxgl-popup-anchor-bottom-left::before,\r\n.mapboxgl-popup-anchor-bottom::before,\r\n.mapboxgl-popup-anchor-bottom-right::before,\r\n.mapboxgl-popup-anchor-top-left::before,\r\n.mapboxgl-popup-anchor-top::before,\r\n.mapboxgl-popup-anchor-top-right::before {\r\n  background: var(--map-popup-border-color);\r\n  filter: brightness(1.25);\r\n  clip-path: polygon(100% 0, 100% 0, 50% 100%, 0 0);\r\n}\r\n\r\n.mapboxgl-popup-anchor-bottom-left::before,\r\n.mapboxgl-popup-anchor-bottom-left::after,\r\n.mapboxgl-popup-anchor-top-left::before,\r\n.mapboxgl-popup-anchor-top-left::after {\r\n  left: 0.75rem;\r\n}\r\n\r\n.mapboxgl-popup-anchor-bottom::before,\r\n.mapboxgl-popup-anchor-bottom::after,\r\n.mapboxgl-popup-anchor-top::before,\r\n.mapboxgl-popup-anchor-top::after {\r\n  left: 0;\r\n  right: 0;\r\n}\r\n\r\n.mapboxgl-popup-anchor-bottom-right::before,\r\n.mapboxgl-popup-anchor-bottom-right::after,\r\n.mapboxgl-popup-anchor-top-right::before,\r\n.mapboxgl-popup-anchor-top-right::after {\r\n  right: 0.75rem;\r\n}\r\n\r\n.mapboxgl-popup-anchor-bottom-left::after,\r\n.mapboxgl-popup-anchor-bottom::after,\r\n.mapboxgl-popup-anchor-bottom-right::after,\r\n.mapboxgl-popup-anchor-top-left::after,\r\n.mapboxgl-popup-anchor-top::after,\r\n.mapboxgl-popup-anchor-top-right::after {\r\n  background: var(--map-popup-background-color);\r\n  clip-path: polygon(calc(100% - 0px) 0, calc(100% - 2px) 0, calc(50% - 0px) calc(100% - 2px), 2px 0);\r\n}\r\n\r\n.mapboxgl-popup-content {\r\n    all: unset;\r\n    background: none;\r\n    padding-bottom: 1rem;\r\n    pointer-events: none !important;\r\n    position: relative;\r\n}\r\n\r\n/* Attribution */\r\n\r\n.mapboxgl-ctrl.mapboxgl-ctrl-attrib {\r\n    box-sizing: content-box;\r\n}\r\n\r\n.mapboxgl-ctrl-attrib.mapboxgl-compact-show .mapboxgl-ctrl-attrib-button {\r\n    background-color: unset;\r\n}\r\n\r\n.mapboxgl-ctrl-attrib-button:focus,\r\n.mapboxgl-ctrl-group button:focus {\r\n    outline: var(--focus-outline);\r\n    box-shadow: none;\r\n}\r\n\r\n.mapboxgl-ctrl-attrib-inner {\r\n    font-family: var(--map-body-font);\r\n    font-size: var(--map-sub-body-font-size);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
